export class NewsPinClass {
    constructor() {
        this.id = 0;
        this.url = "";
        this.title = "";
        this.source = "";
        this.image = "";
        this.timeago = "";
        this.publishedat = "";
        this.pinned = "";
        this.uuid = null;
        this.firstname = "";
        this.name = "";
        this.email = "";
        this.displayname = "";
        this.onlypinned = false;
    }
}
